define('glu/number',['require','numeral'],function(require) {
    'use strict';

    var number = require('numeral');

    return number;
});

